import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from '@/app.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import '@/plugins/array-extensions'
import '@/plugins/string-extensions'
import '@/plugins/directives'
import '@/plugins/filters'
import '@/plugins/auto-declare'
import '@/plugins/axios'
import '@/plugins/session-data'
import '@mdi/font/css/materialdesignicons.css'
import VueAppInsights from 'vue-application-insights'
import { ERROR_TYPES } from './store/modules/error'
import LogRocket from 'logrocket'

if (process.env.VUE_APP_LOGROCKET_KEY) {
  LogRocket.init('jdhwtr/baker-admin')
}

sync(store, router)
Vue.config.productionTip = false

/* This error handler will dispatch an action that will set the error in state and log it to App Insights,
 * and then it will redirect to the error page.
 * Any errors caught here that were NOT first caught by the errorCaptured hook
 * will likely require a page refresh to get the app working again.
*/
Vue.config.errorHandler = (err, vm, info) => {
  err.message = `${err.message} | info: ${info} | vm.$vnode.tag: ${vm.$vnode.tag}`
  console.error(err)
  vm.$store.dispatch(ERROR_TYPES.actions.setError, err)
  if (vm.$route.path !== '/error') {
    vm.$router.push('/error')
      .catch(() => {}) // An error will be thrown if a navigation event was cancelled, but that's fine so just catch and do nothing
  }
}

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueAppInsights, {
  id: process.env.VUE_APP_APP_INSIGHTS_INSTRUMENTATION_KEY,
  router
})
